import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from '../../../types/docs'

function DocsTableOfContents() {
  const { t } = useTranslation()
  const [headings, setHeadings] = useState<Heading[]>([])
  const [activeId, setActiveId] = useState<string>('')

  useEffect(() => {
    // Extract headings from the document
    const articleElement = document.querySelector('.docs-article')
    if (!articleElement) return

    const headingElements = articleElement.querySelectorAll('h2, h3')
    const headingsList: Heading[] = Array.from(headingElements).map(heading => ({
      id: heading.id,
      text: heading.textContent || '',
      level: parseInt(heading.tagName.charAt(1))
    }))

    setHeadings(headingsList)

    // Set up intersection observer for active heading
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id)
          }
        })
      },
      { rootMargin: '-80px 0px -80% 0px' }
    )

    headingElements.forEach(heading => observer.observe(heading))

    return () => observer.disconnect()
  }, [])

  if (headings.length === 0) return null

  return (
    <div>
      <div className='docs-toc-title'>{t('docs.onThisPage')}</div>
      <ul className='docs-toc-list'>
        {headings.map(heading => (
          <li key={heading.id}>
            <a
              href={`#${heading.id}`}
              className={`docs-toc-link ${activeId === heading.id ? 'active' : ''}`}
              style={{ paddingLeft: heading.level === 3 ? '1.5rem' : '0.75rem' }}
              onClick={e => {
                e.preventDefault()
                document.getElementById(heading.id)?.scrollIntoView({ behavior: 'smooth' })
              }}
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DocsTableOfContents
